<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      elevation="0"
      class="pa-4"
      :class="{ 'border-r': !drawer }"
    >
      <div class="d-flex flex-column h-100">
        <div class="text-center mb-6">
          <v-img
            :src="brand.logo"
            width="150"
            class="mx-auto mb-4"
          />
          <div
            v-if="user"
            class="d-flex align-center mb-2"
          >
            <v-avatar
              color="primary-lighten-5"
              class="me-3 border"
              size="40"
            >
              <span class="text-primary text-subtitle-2">{{ user.getInitials() }}</span>
            </v-avatar>
            <div class="text-start">
              <div class="text-body-1 font-weight-medium mb-1">
                {{ user.getFullName() }}
              </div>
              <div class="text-caption text-medium-emphasis">
                {{ user.email }}
              </div>
            </div>
          </div>
        </div>

        <v-divider class="mb-4" />

        <v-list
          nav
          class="px-2"
        >
          <v-list-item
            v-for="item in navItems"
            :key="item.key"
            :to="item.to"
            :title="item.label"
            :value="item.key"
            rounded="lg"
            class="mb-1"
          />
        </v-list>
      </div>
    </v-navigation-drawer>

    <AppBar v-model:drawer="drawer" />
    <ContentView />
  </v-app>
</template>

<script lang="ts" setup>
  import { brand } from '@/config/brand'
  import { portal, resolveNavLabel, FEATURE_CATALOG } from '@/config/portal'
  import { useAuthStore } from '@/stores/auth'

  import AppBar from './common/AppBar.vue'
  import ContentView from './common/AppBarContentView.vue'

  const authStore = useAuthStore()
  const user = computed(() => authStore.getUser)

  const drawer = ref(false)

  const navItems = computed(() =>
    portal.nav.map((item) => ({
      key: item.feature,
      label: resolveNavLabel(item.feature, portal),
      to: { name: FEATURE_CATALOG[item.feature].routeName },
    })),
  )
</script>

<style scoped>
.v-navigation-drawer {
  background: rgb(var(--v-theme-background));
  border-right: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
}

:deep(.v-list-item--active) {
  background: rgb(var(--v-theme-primary-lighten-5));
  color: rgb(var(--v-theme-primary));
}

:deep(.v-list-item) {
  min-height: 44px;
}

:deep(.v-avatar) {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  background-color: rgb(var(--v-theme-primary-lighten-5));
}
</style>
